import React, { useState, useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import { isDesktop } from 'react-device-detect'
import cls from 'classnames'
import { useSelector } from 'react-redux'

import { asyncRoutes, constantRoutes } from './router'
import { filterPermissionPages } from './router/permission'

import './App.css'

function App() {
  const [routes, setRoutes] = useState(constantRoutes)
  const permissions = useSelector((state: any) => state.user.permissions)
  const windowWidth = window.innerWidth || document.body.clientWidth

  useEffect(() => {
    if (permissions && permissions.pages) {
      const filterRoutes = filterPermissionPages(asyncRoutes, permissions.pages)
      const routes = filterRoutes.concat(constantRoutes)
      setRoutes(routes)
    }
  }, [permissions])

  return <div className={cls({ isDesktop: isDesktop && windowWidth > 1024 })}>{useRoutes(routes)}</div>
}

export default App
